import { getCsrfToken } from './apiBase';

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

function requestUrl(input) {
  if (typeof input === 'string') return input;
  if (input && typeof input.url === 'string') return input.url;
  return '';
}

function isSameOrigin(url) {
  if (!url) return true; // relative / no explicit target → same origin
  if (url.startsWith('/')) return true;
  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch (_) {
    return false;
  }
}

/**
 * Wrap window.fetch so every same-origin, state-changing request carries the
 * double-submit CSRF token. This covers both the apiFetch helper and the many
 * components that call fetch() directly, without touching each call site.
 */
export function installCsrfFetch() {
  if (typeof window === 'undefined' || window.__csrfFetchInstalled) return;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const method = String(
      (init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET'
    ).toUpperCase();
    if (!SAFE_METHODS.has(method) && isSameOrigin(requestUrl(input))) {
      const token = getCsrfToken();
      if (token) {
        const headers = new Headers(
          (init && init.headers) ||
            (typeof input !== 'string' && input && input.headers) ||
            undefined
        );
        if (!headers.has('X-XSRF-TOKEN')) headers.set('X-XSRF-TOKEN', token);
        init = { ...init, headers };
      }
    }
    return nativeFetch(input, init);
  };
  window.__csrfFetchInstalled = true;
}
